// HTTP-клиент админки. Сессия — httpOnly-cookie (ставит сервер при входе), скрипты страницы её не видят.
// X-Requested-With обязателен для изменяющих запросов по cookie (защита от CSRF).
import axios from 'axios';

const instance = axios.create({
  baseURL: '/api',
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

// Токен из прежней версии админки больше не используется
try { localStorage.removeItem('adminToken'); localStorage.removeItem('adminRole'); } catch { /* приватный режим */ }

instance.interceptors.request.use((config) => {
  const selectedTenant = localStorage.getItem('adminSelectedTenant');
  if (selectedTenant && selectedTenant !== 'all') {
    config.headers['X-Admin-Tenant-ID'] = selectedTenant;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    if (error.response?.status === 401 && !url.includes('/admin/login') && window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default instance;
